import React from 'react'
import './achievements.css'
import PIC1 from '../../assets/pic1.jpg'
import PIC2 from "../../assets/pic2.jpg";
import PIC3 from "../../assets/pic3.png";
import PIC4 from "../../assets/pic4.jpg";
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import "swiper/css/navigation";
import 'swiper/css/pagination';

const data = [
  
  {
    image: PIC2,
    title: "Second Prize in Hackathon",
    review:
      "Secured second prize in HACKADROIT 24-hour hackathon organized by IEEE PEC. Created a cloud application which stores user data in homomorphically encrypted form.",
  },
  {
    image: PIC3,
    title: "800+ Problems ",
    review:
      "Solved over 800+ problems in the past year involving multiple concepts such as data structures, algorithms, math and design in C++ and Python languages.",
  },
  {
    image: PIC2,
    title: "Pupil Codeforces",
    review:
      "Got a Pupil rating on Codeforces and along with that i had learned some famours algorithms used in Competitive Programming.",
  },
   
];

const Achievements = () => {
  return (
    <section id="achievements">
      <h5>A Few Noteworthy Feats</h5>
      <h2>My Achievements</h2>
      <Swiper
        className="container achievement_container"
        modules={[Navigation, Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        onSwiper={(swiper) => console.log(swiper)}
        onSlideChange={() => console.log("slide change")}
      >
        {data.map(({ image, title, review }, index) => {
          return (
            <SwiperSlide key={index} className="achievement">
              <div className="achievement-image">
                <img src={image} alt="achievement" />
              </div>
              <h5 className="achievement_name">{title}</h5>
              <small className="achievement_review">{review}</small>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
}

export default Achievements